var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-data"},[_c('img',{attrs:{"src":_vm.imgUrl,"alt":"暂无数据"}}),_c('p',{staticClass:"text"},[_vm._v("暂无数据")])])}
var staticRenderFns = []

export { render, staticRenderFns }